import { BehaviorSubject } from "rxjs";

export class CORE_PROPS {
  _platform_details = new BehaviorSubject<any>({});
  _device_details = new BehaviorSubject<any>({});

  constructor() { }


  getCorePlatformDetails() {
    return this._platform_details.asObservable();
  }

  setCorePlatformDetails(platform) {
    this._platform_details.next(platform)
  }

  getDeviceDetails() {
    return this._device_details.asObservable();
  }

  setDeviceDetails(devices) {
    this._device_details.next(devices)
  }

}
